export enum PublisherTier {
  // needs to add what API accepts
  InternalPremium = 'InternalPremium',
  ManagedPremium = 'ManagedPremium',
  SelfServeStandard = 'SelfServeStandard',
  SelfServe3rdParty = 'SelfServe3rdParty',
  SelfServe1stParty = 'SelfServe1stParty',
  SelfServe1stPartyBoost = 'SelfServe1stPartyBoost',
}
